import { Decimal } from 'decimal.js'
import { QuoteType } from '@/lib/types'

export const DISCOUNT_SPLIT_CUTOFF_DATE = new Date('2026-05-07T08:00:00.000Z')

type OriginalQuoteActivation = {
  dsy_activatedon?: string | null
  dsy_approvalsignaturedatetime: string | null
}

export function isLegacyDiscountChain(
  quoteType: QuoteType | null | undefined,
  originalQuote: OriginalQuoteActivation | null | undefined
) {
  const originalActivation = originalQuote?.dsy_activatedon ?? originalQuote?.dsy_approvalsignaturedatetime
  return (
    quoteType === QuoteType.ChangeOrder &&
    !!originalActivation &&
    new Date(originalActivation) < DISCOUNT_SPLIT_CUTOFF_DATE
  )
}

export const splitConservesDiscount = (total: number, taxable: number, nonTax: number) =>
  Math.abs(total - (taxable + nonTax)) <= 0.011

export const getLaborDiscountLineAmount = (total: number, taxable: number, isLegacyChain: boolean) =>
  isLegacyChain ? total : taxable

export const getLaborDiscountLineTaxability = (laborTax: number, isLegacyChain: boolean) =>
  isLegacyChain ? laborTax !== 0 : true

export const hasRequiredDiscountLines = (
  isLegacyChain: boolean,
  hasTaxableLine: boolean,
  hasNonTaxLine: boolean
) => hasTaxableLine && (isLegacyChain || hasNonTaxLine)

/** Capture each row's fixed input before its calculated price is overwritten.
 * Quantity becomes one; percentage remains independent from the fixed dollars. */
export function getNormalizedDiscountInputs(detail: {
  manualdiscountamount: number | null
  priceperunit: number | null
  quantity: number
  dsy_cpqfields: { dsy_laborfactorpercent: number | null }
}) {
  return {
    manualdiscountamount: new Decimal(detail.manualdiscountamount ?? detail.priceperunit ?? 0)
      .mul(detail.quantity).abs().toDecimalPlaces(2).toNumber(),
    dsy_laborfactorpercent: detail.dsy_cpqfields.dsy_laborfactorpercent ?? 0,
  }
}
